/** @ignore *//** */
const config = {
  version: '2.14.1',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts